<ng-template #modalPdf let-modal>
    <div class="modal-header">
        <div class="d-flex align-items-center">
            <h5 class="modal-title fw-bold mb-0">
                <span *ngIf="configs && configs.filename">{{configs.filename | translate}}</span>
            </h5>
            <i class="icp-document icp-icon-40 ms-2 cursor-pointer" (click)="downloadPhysicalPdf()"></i>
        </div>
		<button type="button" class="btn custom-close-button" aria-label="Close"(click)="closeModal()"><i class="icp-icon-40 icp-close d-block"></i></button>
	</div>
    <div *ngIf="wait" class="d-flex align-items-center justify-content-center p-3">
        <div class="spinner-border text-danger"></div>
    </div>
    <div *ngIf="configs && pdfSrc && !wait && !isImage" class="modal-body pt-2 pb-2">
        <pdf-viewer [src]="pdfSrc" [render-text]="true" [original-size]="false" [autoresize]="true"
        (after-load-complete)="afterLoadComplete($event)"></pdf-viewer>
    </div>
    <div *ngIf="configs && !wait && isImage">
        <img [src]="configs.url" alt="" class="w-100 p-4">
    </div>
    <div *ngIf="configs && configs.check" class="modal-footer">
        <div class="d-flex w-100 align-items-center justify-content-center">
            <!-- <button (click)="downloadPhysicalPdf()" class="btn btn-primary">Download</button> -->
            <button *ngIf="configs.check" class="btn btn-primary w-100" [disabled]="disableCheck" (click)="checkPdf()">{{"common-accept" | translate}}</button>
        </div>
    </div>
</ng-template>